import { Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@heroui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import PropTypes from "prop-types"

const modes = {
  STANDARD: {
    id: "standard",
    label: "Standard",
    description: "View all slot statuses.",
    buttonCaption: "Standard Mode",
  },

  AVAILABILITY: {
    id: "availability",
    label: "Availability",
    description: "Quickly toggle between available and disabled.",
    buttonCaption: "Availability Mode",
  },
  
  BULK_AVAILABILITY: {
    id: "bulk_availability",
    label: "Bulk Availability",
    description: "Toggle multiple slots / groups.",
    buttonCaption: "Bulk Mode",
  },
}

const AvailabilityModeToggle = ({ handleModeChange, mode }) => {
  const currentMode = modes[mode.toUpperCase()] ?? modes.STANDARD

  return (
    <ButtonGroup variant="solid" color="primary">
      <Button>{currentMode.buttonCaption}</Button>

      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <Button isIconOnly>
            <ChevronDownIcon />
          </Button>
        </DropdownTrigger>

        <DropdownMenu
          disallowEmptySelection
          aria-label="Mode Selector"
          className="max-w-[300px]"
          selectedKeys={new Set([mode])}
          selectionMode="single"
          onSelectionChange={(value) => handleModeChange(value.currentKey)}
        >
          {Object.values(modes).map((mode) => (
            <DropdownItem key={mode.id} description={mode.description}>
              {mode.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  )
}

AvailabilityModeToggle.propTypes = {
  handleModeChange: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(["standard", "availability", "bulk_availability"]).isRequired,
}

export default AvailabilityModeToggle